const preference = {
  title: "Preferences",
  account: {
    title: "アカウント",
    subtitle: "アカウント設定を管理する",
    avatar: "アバター",
    username: "ユーザー名",
    email: "メールアドレス（非公開）",
    introduction: "自己紹介",
    introductionPlaceholder: "自己紹介を入力",
    introductionDescription: "自己紹介は、「Notes Nebura」「Studio Juno」で公開されます。",
    modeSwitch: "アカウントタイプ切り替え",
    modeSwitchDescription: "個人アカウントと組織アカウントを切り替えることができます",
    switchToEnterprise: "組織アカウントに切り替え",
    switchToPersonal: "個人アカウントに切り替え",
    switchedToEnterprise: "組織アカウントに切り替えました",
    switchedToPersonal: "個人アカウントに切り替えました",
    deleteDialog: {
      title: "アカウントの無効化",
      description:
        "アカウントが無効化され、ログインできなくなります。一部の公開データはアクセス可能な状態で残る場合があります。",
      personalUser: "個人アカウントが無効化されます。組織アカウントは影響を受けません。",
      enterpriseUser: "組織アカウントが無効化されます。個人アカウントは影響を受けません。",
      lastOwner: "あなたは組織の最後のオーナーです。先に他のメンバーをオーナーに昇格させてください。",
      confirm: "無効化",
      error: {
        common: "アカウントの無効化に失敗しました。サポートに問い合わせてください。",
        subscription: "有料プランに加入しているため、アカウントを無効化できません。プラン解約後、無効化してください。",
        owner_protection:
          "あなたは組織の最後のオーナーのため、アカウントを無効化できません。先に他のメンバーをオーナーに昇格させてください。",
        owner_protection_with_org:
          "あなたは組織「{{organizationName}}」の最後のオーナーのため、アカウントを無効化できません。先に他のメンバーをオーナーに昇格させてください。",
        deactivated: "アカウントが無効化されました。",
      },
    },
  },
  invitation: {
    title: "組織招待",
    description: "あなた宛の組織からの招待を管理します",
    noInvitations: "現在、未承諾の招待はありません",
    invitedBy: "招待者",
    acceptedSuccess: "組織「{{organization}}」への招待を承諾しました",
    declinedSuccess: "招待を辞退しました",
    acceptError: "招待の承諾処理に失敗しました",
    declineError: "招待の辞退処理に失敗しました",
    alreadyInOrganization: "すでに組織に所属しているため、新しい招待を受け付けることができません",
    leaveFirstMessage: "他の組織に参加するには、現在の組織から脱退する必要があります",
  },
  enterprise: {
    title: "エンタープライズ",
    noEnterpriseInfo: "エンタープライズ情報が利用できません",
    notEnterpriseMode: "組織アカウントではありません",
    info: "組織情報",
    members: "メンバー管理",
    settings: "組織設定",
    usage: "使用状況",
    readOnlyMode: "組織設定の閲覧のみ可能です。変更には権限が必要です。",

    // 組織情報コンポーネント
    organizationDetails: "組織詳細",
    organizationName: "組織名",
    editName: "組織名を編集",
    contractPeriod: "クレジット有効期間",
    fromTo: "{{from}} 〜 {{to}} ",
    creditPool: "クレジットプール",
    creditUsage: "クレジット使用状況",
    memberCount: "メンバー数",
    yourRole: "あなたの役割",
    role: {
      owner: "オーナー",
      manager: "マネージャー",
      member: "メンバー",
    },
    selfEditDisabled: "自分自身のロールは変更できません",
    selfDeleteDisabled: "自分自身は削除できません",
    suspendMember: "メンバーを停止",
    activateMember: "メンバーを再開",
    leave: "組織を脱退",
    leaveConfirm: "本当に組織を脱退しますか？",

    // メンバー管理コンポーネント
    memberManagement: "メンバー管理",
    inviteMembers: "メンバーを招待",
    inviteMember: "メンバーを招待",
    invitationManagement: "招待管理",
    currentMembers: "現在のメンバー",
    memberList: "メンバーリスト",
    invitationList: "招待リスト",
    organizationId: "組織ID",
    selectOrganization: "組織を選択",
    loadingOrganizations: "読み込み中...",
    noOrganizations: "利用可能な組織がありません",
    switchMode: "切り替え",
    member: {
      name: "名前",
      email: "メールアドレス",
      role: "役割",
      status: "ステータス",
      joinedAt: "参加日",
      editRole: "役割を編集",
      editUser: "メンバー編集",
      lastOwnerWarning: "最後のオーナーは変更できません。新しいオーナーを追加してから変更してください。",
      selfStatusChangeDisabled: "自分自身のステータスは変更できません。",
      statusActive: "有効",
      statusInactive: "無効",
      manageRoleStatus: "{{username}} {{email}}のロールとステータスを管理します。",
    },
    invitation: {
      email: "メールアドレス",
      role: "役割",
      sentAt: "送信日",
      expiresAt: "有効期限",
      status: "ステータス",
      accepted: "承諾済み",
      pending: "保留中",
      invite: "招待",
      title: "組織への招待",
      message: "あなたは組織「{{organization}}」に{{role}}として招待されています。招待者: {{inviter}}",
      expires_at: "この招待は{{date}}まで有効です。",
      accept: "承諾する",
      decline: "辞退する",
      administrator: "管理者",
    },
    active: "有効",
    suspended: "停止",
    pending: "保留中",
    inviteDescription: "招待するメンバーのメールアドレスと役割を入力してください。",
    confirmDeleteMember: "メンバーを削除",
    confirmDeleteMemberText: "このメンバーを組織から削除してもよろしいですか？この操作は取り消せません。",
    deleteMember: "メンバーを削除",
    resendInvitation: "招待を再送信",
    cancelInvitation: "招待をキャンセル",
    delete: "削除",
    confirmRemove: "本当にこのメンバーを削除しますか？",
    confirmSuspend: "本当にこのメンバーを停止しますか？",
    confirmActivate: "このメンバーを有効化しますか？",
    confirmPromote: "このメンバーを昇格させますか？",
    confirmDemote: "このメンバーを降格させますか？",
    inviteSuccess: "招待を送信しました",
    inviteError: "招待の送信に失敗しました",
    error: {
      fetchMembers: "メンバー情報の取得中にエラーが発生しました。",
      fetchInvitations: "招待情報の取得中にエラーが発生しました。",
      updateMember: "メンバー情報の更新中にエラーが発生しました。最後のオーナーは変更できません。",
      emailRequired: "メールアドレスを入力してください。",
      nameRequired: "組織名を入力してください。",
      inviteMember: "メンバー招待中にエラーが発生しました。",
      deleteMember: "メンバー削除中にエラーが発生しました。",
      resendInvitation: "招待再送信中にエラーが発生しました。",
      cancelInvitation: "招待キャンセル中にエラーが発生しました。",
      fetchSettings: "組織設定の取得中にエラーが発生しました。",
      saveSettings: "設定の保存中にエラーが発生しました。",
      updateName: "組織名の更新中にエラーが発生しました。",
      fetchUsageData: "使用状況データの取得中にエラーが発生しました。",
      exportData: "データのエクスポート中にエラーが発生しました。",
      log: {
        fetchUsageData: "使用状況データ取得エラー:",
        exportData: "使用状況エクスポートエラー:",
      },
    },
    success: {
      updateMember: "メンバー情報を更新しました",
      deleteMember: "メンバーを削除しました",
      resendInvitation: "招待を再送信しました",
      cancelInvitation: "招待をキャンセルしました",
      saveSettings: "設定が正常に保存されました",
      updateName: "組織名を更新しました",
    },
    // 組織設定コンポーネント
    securitySettings: "セキュリティ設定",
    securityLevel: "セキュリティレベル",
    securityLevels: {
      standard: "標準",
      strict: "厳格",
      enterprise: "エンタープライズ",
    },
    contentFilterStrength: "コンテンツフィルター強度",
    weak: "弱",
    strong: "強",
    featureSettings: "機能設定",
    disableImageGeneration: "画像生成を無効化",
    disableVoiceGeneration: "音声生成を無効化",
    disableCreditPurchases: "クレジット購入を無効化",
    disableAdultContent: "成人向けコンテンツを無効化",
    defaultSettings: "デフォルト設定",
    defaultLanguage: "デフォルト言語",
    saving: "保存中...",
    saveSettings: "設定を保存",

    // Organization Features
    organizationFeatures: "組織機能",
    mindMapEnabled: "マインドマップの有効化",
    browsingEnabled: "ブラウジング（チャット）の有効化",
    colorPaletteEnabled: "カラーパレットの有効化",
    promptTemplateEnabled: "プロンプトテンプレートの有効化",
    writingAIEnabled: "ライティングAIの有効化",
    imageGenerationEnabled: "画像生成の有効化",
    videoGenerationEnabled: "動画生成の有効化",
    soundGenerationEnabled: "音源生成の有効化",
    imageSafetyLevel: "画像安全性レベル",
    articlePublishingEnabled: "記事公開の有効化",
    organizationSettingsOverride: "これらの設定はユーザー個人の設定より優先されます",

    // 使用状況レポート
    usageReport: "使用状況レポート",
    period: "期間",
    periods: {
      week: "週間",
      month: "月間",
      quarter: "四半期",
      year: "年間",
      contract: "契約期間",
    },
    usageHistory: "使用履歴",
    startDate: "開始日",
    endDate: "終了日",
    selectedMember: "メンバー選択",
    allMembers: "全メンバー",
    exportData: "データをエクスポート",
    summary: "サマリー",
    totalCreditsUsed: "総使用クレジット",
    memberUsage: "メンバー別使用状況",
    dateTime: "日時",
    page: "ページ",
    action: "アクション",
    credits: "クレジット",
    totalCredits: "総クレジット",
    status: "状態",
    charged: "使用済み",
    refunded: "払戻済み",
    loading: "読み込み中...",
    last7Days: "過去7日間",
    last30Days: "過去30日間",
    last90Days: "過去90日間",
    custom: "カスタム",
    totalUsage: "合計使用量",
    usedCredits: "使用済みクレジット",
    topUsers: "トップユーザー",
    user: "ユーザー",
    creditsUsed: "使用済みクレジット",
    percentage: "割合",
    creditsByFeature: "機能別クレジット使用量",
    feature: "機能",
    dailyUsage: "日次使用量",
    noData: "データがありません",
    switchToPersonal: "個人モードに切り替え",
  },
  // 機能制限モーダル
  restriction: {
    title: "組織管理者により制限されています",
    message: "この機能（{{feature}}）は管理者によって制限されています。",
  },
  // 機能名の表示
  features: {
    mindMap: "マインドマップ",
    browsing: "ブラウジング",
    colorPalette: "カラーパレット",
    promptTemplate: "プロンプトテンプレート",
    writingAI: "ライティングAI",
    imageGeneration: "画像生成",
    videoGeneration: "動画生成",
    voiceGeneration: "音声生成",
    soundGeneration: "音源生成",
    unknownFeature: "-",
  },
  settings: {
    title: "設定",
    appearance: "外観",
    uiLanguage: "UI言語",
    uiLanguageDescription: "ユーザーインターフェースの言語",
    aiLanguage: "AI言語",
    aiLanguageButton: "AI言語設定",
    aiLanguageDescription: "AIの応答言語",
    aiEngine: "AIエンジンモード",
    aiEngineDescription:
      "テキスト生成のAIエンジンモードを選択します。o4-mini, GPT-4o, Claude 3.7 Sonnet, GPT-4o-mini の中から適宜切り替えられます。この設定は右上のユーザーアイコンからいつでも変更できます。",
    country: "国",
    countryDescription: "国を選択し、検索結果を最適化します。",
    urlMode: {
      title: "URL参照モード",
      description:
        "AIがURLを参照するモードを選択します。モード '厳密' は、大量のクレジットを消費する可能性があります。",
      strict: "厳密",
      economy: "エコノミー",
    },
  },
  planAndBillings: {
    title: "サブスクリプションと請求",
    credit: "クレジット残高",
    totalCredit: "合計クレジット",
    monthlyCredit: "月額クレジット",
    dailyCredit: "デイリークレジット",
    extraCredit: "追加クレジット",
    dailyRefresh: "デイリー更新",
    subscriptionPeriod: "サブスクリプション期間",
    currentPlan: "サブスクリプションプラン",
    upgrade: "アップグレード",
    billings: "サブスクリプション請求履歴",
    cancel: "サブスクリプションのキャンセル",
    reactivate: "サブスクリプションの再開",
    invoice: "顧客ポータルで請求書を確認",
    noInvoice: "請求書はありません。",
    aboutCredit: "クレジットについて",
    checkoutHistory: "購入履歴",
    checkoutHistoryNote: "アップグレードとクレジットの購入（過去12ヶ月）",
    receipt: "領収書",
    document: "ドキュメント",
    selectHistory: "履歴を選択",
    pleaseSelect: "選択してください",
    resetDate: "リセット日時",
    upgradeModal: {
      title: "プランをアップグレード",
      description: "プランをアップグレードすると、より多くの機能を利用できます。",
      caution1: "アップグレードすると、即時にクレジットが加算され、機能制限が開放されます。",
      caution2: "すでに有料プランに加入済みの場合は、差額が請求されます。",
      caution3: "次回請求日（クレジット失効日）は変更されません。次回請求日は、顧客ポータルで確認できます。",
      caution4: "購入すると、上記及び、利用規約、プライバシーポリシーに同意したものとみなされます。",
      price: "請求額",
      nextPrice: "次回請求額",
      newPlan: "新しいプラン",
      upgrade: "アップグレード（JCB非対応）",
      upgrade_jcb: "JCB / ドル決済非対応カードはこちら",
    },
  },
  // 共通
  common: {
    ok: "OK",
  },
  misc: {
    title: "その他",
    privacyPolicy: "プライバシーポリシー",
    termsOfService: "利用規約",
    contact: "お問い合わせ",
    startContact: "お問い合わせを開始",
    confirm: "確認する",
    contactModal: {
      title: "お問い合わせ",
      description: "お問い合わせ内容を入力してください。",
      warn: "Tenak AI に関するご質問以外、一般的な AI の使い方やご相談には対応いたしかねます。\nまた、フリープランはサポート対象外です。ご了承ください。",
      subject: "タイトル",
      type: {
        description: "お問い合わせ種別を選択してください。",
        question: "質問",
        problem: "不具合の報告",
        payment: "支払いに関して",
        request: "ご意見、ご要望",
        enterprise: "エンタープライズに関して",
        other: "その他",
      },
      name: "お名前",
      email: "メールアドレス",
      message: "お問い合わせ内容",
      send: "送信",
      error: "お問い合わせに失敗しました。時間をおいてから、もう一度お試しください。",
      success: "お問い合わせを受け付けました。担当者から追ってご連絡いたします。",
    },
  },
};
export default preference;
